module.exports = __webpack_public_path__ + "img/09.7fac3f66.jpg";